import SkorDefaultLoader from "../../../../assets/img/skorDefaultLoader.gif";

const LoadingScreen = ({ message }: { message: string }) => (
  <div className="custom-kyc-uploading">
    <div className="defaultSkorLoaderParent">
      <img
        src={SkorDefaultLoader}
        className="defaultSkorLoader"
        alt="Loading"
      />
    </div>
    <p>{message}</p>
  </div>
);

export default LoadingScreen;
